import { Component, OnInit } from '@angular/core';

import { SimpleComponent } from '../../common/simple.component';

@Component({
	selector: 'app-tourism-stops',
	templateUrl: './tourism-stops.component.html',
	styleUrls: ['./tourism-stops.component.css'],
})
export class TourismStopsComponent extends SimpleComponent {
	protected apiUrl = 'TourismStops';
	elements: Array<TourismStop> = [];
	// public loader: boolean = true;
	data: TourismStop = {
		id: null,
		code: null,
		name: null,
		destinations: null,
		domestic: null,
		swinging: null,
		costswinging: null,
		x: null,
		y: null,
		detail: null,
	};
	tableRows = [
		{ id: 'id', name: 'ID' },
		{ id: 'code', name: 'Code' },
		{ id: 'name', name: 'Name' },
		{ id: 'destinations', name: 'Destinations' },
		{ id: 'domestic', name: 'Domestic' },
		{ id: 'swinging', name: 'Wahadło' },
		{ id: 'detail', name: 'Adres' },
	];
}
export interface TourismStop {
	id: number;
	code: string;
	name: string;
	destinations: string;
	domestic: boolean;
	swinging: boolean;
	costswinging: string;
	x: number;
	y: number;
	detail: string;
}
